import React, { Component } from 'react';
// import PropTypes from "prop-types";
import { connect } from "react-redux";
import { setTitle } from "../actions/AppActions";
import { withRouter } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import moment from "moment";
// import "moment/locale/de";
// import "moment/locale/en-gb";
// import "moment/locale/nl";
import DateHelper from "../helpers/date-helper";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { createStructuredSelector } from "reselect";
import getDayAppointmentsSelector from "../selectors/TasksDailySelector";
import { bocksSelector, settings, filterInfo } from '../selectors/SelectedAppointmentSelector';
import { Text } from '../extensions/LangaugeContainer';
//import { red } from '@material-ui/core/colors';
// import "moment/min/locales";

const styles = {
  div: {
    display: "block",
    paddingLeft: "10px",
    zIndex: 999,
    fontSize: "20px",
    textAlign: "left"
  },
  divInline: {
    display: "inline-block",
    textAlign: "right",
    paddingRight: "10px",
    zIndex: 999,
    fontSize: "0.7em"
  },
  par: {
    height: 70,
    marginTop: 0
  },
  appbar: {
    top: 0,
    zIndex: 1000,
  },
  appBarOnMultipleToureDays:{
    top: 0,
    zIndex: 1000,
    backgroundColor: '#357a38'
  },
  card: {
    margin: "10px",
    boxShadow: "1px 1px 1px 1px #AAA",
    borderRadius: "0px",
    textAlign: "left",
    color: "#444",
    // backgroundColor: "red"
  },
  card1: {
    margin: "10px",
    boxShadow: "1px 1px 1px 1px #AAA",
    borderRadius: "0px",
    textAlign: "left",
    color: "#444",
     backgroundColor: "red"
  },
  cont: {
    overflowY: "scroll",
    height: "calc(100vh - 126px)",
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: 0
  }
};

class DayTasks extends Component{

  getDateTimeString = date => {
    moment.locale(this.props.settings.CurrentLang);
    return moment(date).format("DD. MMMM YYYY HH:mm");
  };

  getDayName = () => {
    let day = this.props.day;
    var d = new DateHelper().getDateByIndex(day);
    moment.locale(this.props.settings.CurrentLang);
    return d.format("dddd");
  };

  getDateString = () => {
    moment.locale(this.props.settings.CurrentLang);
    let day = this.props.day;
    var d = new DateHelper().getDateByIndex(day);
    return d.format("MMMM DD, YYYY");
  };

  hasVerladeplatz = (data) => {
    let beladeList = [];
    data.forEach(function (f) {
      if (beladeList.filter(function (w) {
        return w === f.VerladeRampe
      }).length === 0) beladeList.push(f.VerladeRampe);
    })
    return beladeList.length > 0;
  }

  calculateVerladeplatz = (data) => {
    let beladeList = [];
    data.forEach(function (f) {
      if (beladeList.filter(function (w) {
        return w === f.VerladeRampe
      }).length === 0) beladeList.push(f.VerladeRampe);
    })
    return beladeList.toString();
  }

  calculateBeladeStatus = (data) => {
    let allItems = 0;
    let finishedItems = 0;
    data.forEach(function (f) {
      allItems += f.CountAll;
      finishedItems += f.CountBeladen;
    })
    let retValue = (100 / allItems) * finishedItems;
    return !Number.isNaN(retValue) ? parseFloat(retValue).toFixed(1) : 0;
  }

  ShowAuftrag = val => {
    // this.props.settings.PrivilegedUser ? this.props.history.push("/taskro/" + val.id ): 
    this.props.history.push("/task/" + val.id );
  };

  ShowBockAbholung = val => {
    this.props.history.push("/bockabholung/" + val.id ); // + val.id
  };

  AddPerson = val => {
    this.props.history.push("/task")
  }


  
  header = (data) => {
    let startToure = data[0] ? moment(data[0].Datum).format("MMMM DD, YYYY")  : "";
    let endToure = data[0] ? moment(data[0].EndDatum).format("MMMM DD, YYYY") : "";
    let toureMultipleDays = startToure === endToure ? false : true;
    let dh= new DateHelper();
    let durationOfToure = dh.appDuration(moment(data[0]&&data[0].Datum),moment(data[0] && data[0].EndDatum))+1; //računa koliko traje tura
    let startDay = data[0] && moment(data[0].Datum).date(); //početni dan ture
    let dateByIndex = moment(dh.getDateByIndex(this.props.day)).date(); //dobavlja datum po indexu

    return (
      <AppBar position="static" style={toureMultipleDays ? styles.appBarOnMultipleToureDays : styles.appbar}>
        <Grid container direction="row" spacing={0} justify="flex-start" alignItems="center">
         <Grid item xs={6} sm={3} md={2} lg={2}>
            <div style={styles.div}>
              <Typography component="p" style={{fontSize: '0.7em', color:"#FFFFFF"}}>
               {this.getDayName()}
              </Typography>
            </div>
            <div style={styles.div}>
              <Typography component="p" style={{fontSize: '0.7em', color:"#FFFFFF", marginTop:"0px"}}>
                {this.getDateString()}
              </Typography>
            </div>
          </Grid>
          {(startToure !== "" || endToure !== "") && <Grid item xs={6} sm={3} md={4} lg={4}>
            <div style={styles.div}>
              <Typography component="p" style={{fontSize: '0.7em', color:"#FFFFFF"}}>
                {/* Toure start */}
                {<Text tid="start" />}: {startToure}
              </Typography>
            </div>
            <div style={styles.div}>
              <Typography component="p" style={{fontSize: '0.7em', color:"#FFFFFF", marginTop:"0px"}}>
                {/* Toure end */}
                {<Text tid="end" />}: {endToure}
              </Typography>
            </div>
          </Grid> 
          }
          {this.hasVerladeplatz(data) && (
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <div style={styles.divInline} ><Text tid="loadingPlace"/>:<span style={{color:"#FF8100", fontSize: 24, fontWeight: "bold"}}>{this.calculateVerladeplatz(data)}</span></div>

              <div style={styles.divInline}><Text tid="loadingStatus"/>:<span style={{color:"#FF8100", fontSize: 24, fontWeight: "bold"}}>{this.calculateBeladeStatus(data)}%</span></div>
            </Grid>
          )}
        </Grid>
        {toureMultipleDays === true ? <Grid><Text tid="mehrTagesTour"/> {Math.abs(dateByIndex-startDay+1)+'/'+durationOfToure} </Grid> : <Grid><Text tid="tagesTour"/></Grid>}
      </AppBar>
    );
  };

  render(){
    //console.log("DayTask, ", this.props.appointments);
  //   let data = this.props.appointments;
  
    //console.log("Daytasks:", this.props);
  let appointments = this.props.appointments || [];
  let bockAbholung = appointments.filter(b => b.AuftragNr === "Bock abholung") || []; //Bokovi koji se nalaze kod kupca, koje treba pokupiti.
  let appointmentsWithoutBocks = appointments.filter(a => a.AuftragNr !== "Bock abholung") || []; //Standardni appointmenti bez bokova koji se nalaze kod kupca.

    return (
      <div style={styles.back}>
        <div style={styles.par}>{this.header(this.props.appointments)}</div>
          <div style={styles.cont}>
            {bockAbholung.map(val => (
            <Card
              key={val.id}
              raised
              style={styles.card}
            >
              <CardContent
                onClick={() => this.ShowBockAbholung(val)}
              >
                <div>
                  <Typography component="p" style={{ fontSize: 22, color: "#888888" }}>
                    <b>{val.EkName} </b>
                  </Typography>
                </div>
                <div>
                  <Typography component="p" style={{ fontSize: 16 }}>
                    <span style={{ color: "#00B0DE" }}><Text tid="bockNumber"/>: </span><span><b>{val.Bock_Nr || 0}</b></span>
                  </Typography>
                </div>
                <div>
                  <Typography component="p" style={{ fontSize: 16 }}>
                    <span style={{ color: "#00B0DE" }}><Text tid="street"/>: </span><span>{val.EkStrasse || ""}</span>
                  </Typography>
                </div>
                <div>
                  <Typography component="p" style={{ fontSize: 16 }}>
                    <span style={{ color: "#00B0DE" }}><Text tid="zipCodePlace"/>: </span><span>{val.EkPLZ || ""}{" "}{val.EkOrt || ""}</span>
                  </Typography>
                </div>
                <div>
                  <Typography component="p" style={{ fontSize: 16 }}>
                    <span style={{ color: "#00B0DE" }}><Text tid="deliveryDate"/>: </span><span>{moment(val.DestinationDate).format("DD.MM.YYYY / HH:mm")}</span>
                  </Typography>
                </div>


              </CardContent>
            </Card>
            ))}

            {appointmentsWithoutBocks.map(val => (
              <Card
                 key={val.id}
                 raised
                 style={{
                  margin: "10px",
                  boxShadow: "1px 1px 1px 1px #AAA",
                  borderRadius: "0px",
                  textAlign: "left",
                  color: "#444",
                  backgroundColor: val.color }}
              >
                <CardContent
                  onClick={() => this.ShowAuftrag(val)}
                >
                  <div>
                    <Typography component="p" style={{fontSize: 22, color:"#888888"}}>
                      <b>{val.Kunde} {val.Kunden_Nr !== "0" ? val.Kunden_Nr : ""}</b>
                    </Typography>
                  </div>
                  <div>
                    <Typography component="p" style={{fontSize:16}}>
                      <span style={{color:"#00B0DE"}}>Auftrag nr: </span><span><b>{val.AuftragNr || ""}</b></span>
                    </Typography>
                  </div>
                  <div>
                    <Typography component="p" style={{fontSize:16}}>
                      <span style={{color:"#00B0DE"}}><Text tid="EkName"/>: </span><span>{val.EkName || ""}</span>
                    </Typography>
                  </div>
                  <div>
                    <Typography component="p" style={{fontSize:16}}>
                      <span style={{color:"#00B0DE"}}><Text tid="street"/>: </span><span>{val.EkStrasse || ""}</span>
                    </Typography>
                  </div>
                  <div>
                    <Typography component="p" style={{fontSize:16}}>
                      <span style={{color:"#00B0DE"}}><Text tid="zipCodePlace"/>: </span><span>{val.EkPLZ || ""} + {" "} + {val.EkOrt || ""}</span>
                    </Typography>
                  </div>
                  <div>
                    <Typography component="p" style={{fontSize:16}}>
                      <span style={{color:"#00B0DE"}}><Text tid="bock"/>: </span><span>{val.Bock === null ? 0 : val.Bock}</span>
                    </Typography>
                  </div>
                  <div>
                    <Typography component="p" style={{fontSize:16}}>
                      <span style={{color:"#00B0DE"}}><Text tid="positions"/>: </span><span>{val.PositionCount || 0}</span>
                    </Typography>
                  </div>
                  <div>
                    <Typography component="p" style={{fontSize:16}}>
                      <span style={{color:"#00B0DE"}}><Text tid="commission"/>: </span><span>{val.Kommision || ""}</span>
                    </Typography>
                  </div>
                  <div>
                    <Typography component="p" style={{fontSize:16}}>
                      <span style={{color:"#00B0DE"}}><Text tid="deliveryDate"/>: </span><span>{moment(val.DestinationDate).format("DD.MM.YYYY / HH:mm")}</span>
                    </Typography>
                  </div>
                </CardContent>
              </Card>
              ))}
          </div>

      </div>
    )
  }
}

// const mapStateToProps = state => ({
//   appointments: getDayAppointmentsSelector,
//   bocks: bocksSelector,
//   settings: settings,
//   showToureInfo: state.tasks.shownType,
// });
const mapStateToProps = createStructuredSelector({
  appointments: getDayAppointmentsSelector(),
  bocks: bocksSelector,
  settings: settings,
  showToureInfo: filterInfo,
});

export default withRouter(
  connect(
    mapStateToProps,
    {
      setTitle
    }
  )(DayTasks)
);